import type { AnalyticsSender } from '@funtech-int/yango-shared';
import { Person } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import {
    MovieCardTabTitle,
    SelectionErrorType,
    SelectionImpressionEntity,
} from '@kinopoisk-int/evgen-web-events/web/named_enums';
import {
    selectionErrorRaised,
    selectionMovieImpressionWithCardSelectedV2,
    selectionMovieImpressionWithCardShowedV2,
    selectionShowed,
} from '@kinopoisk-int/evgen-web-events/web/selection';

import { normalizeItemPosition } from '@/shared/lib/analytics/selection';

export const createAnalyticsEvents = (eventSender: AnalyticsSender) => ({
    showed(personId: number) {
        eventSender.sendOnce(selectionShowed, { selectionId: personId.toString() ?? '-' });
    },
    error(personId: number, name?: string) {
        eventSender.send(selectionErrorRaised, {
            selectionId: personId.toString() ?? '-',
            selectionName: name ?? '-',
            errorType: SelectionErrorType.EmptySelection,
            errorTitle: '404',
            errorMessage: 'Not found',
            requestId: '-',
        });
    },
    createFilmographyCardAnalyticsEvents(person: Person) {
        return {
            cardClicked(position: number, contentId: string, title: string) {
                eventSender.send(selectionMovieImpressionWithCardSelectedV2, {
                    uuid: contentId ?? '-',
                    title: title ?? '-',
                    entityType: SelectionImpressionEntity.MovieIcon,
                    cardPosition: normalizeItemPosition(position),
                    selectionId: person.id.toString() ?? '-',
                    selectionName: person.name ?? '-',
                    windowSessionId: '-',
                    tabTitle: MovieCardTabTitle.About,
                });
            },
            cardViewed(position: number, contentId: string, title: string) {
                eventSender.sendOnce(selectionMovieImpressionWithCardShowedV2, {
                    uuid: contentId ?? '-',
                    title: title ?? '-',
                    entityType: SelectionImpressionEntity.MovieIcon,
                    cardPosition: normalizeItemPosition(position),
                    selectionId: person.id.toString() ?? '-',
                    selectionName: person.name ?? '-',
                    windowSessionId: '-',
                });
            },
        };
    },
});
